export default {
  title: {
    jobList: 'Position List',
    jobDetail: 'Job Detail'
  },
  menu: {
    jobList: 'Job List'
  },
  label: {
    title: 'Company Info',
    jobAlert: 'Job Alert',
    followUs: 'Follow Us',
    availableJobs: 'Available Jobs',
    totalJobCount: 'Total of {count} jobs open',
    jobLocationCount: 'Job available in {count} locations',
    remoteWork: 'Remote work',
    outsideWork: 'Outside work',
    keyword: 'Keywords',
    shareButton: 'Refer / Share'
  },
  placeholder: {
    searchJobs: 'Search Jobs',
    searchPlaceholder: 'Please input {keyName}',
    filter: 'Keywords search'
  },
  btn: {
    createJobAlert: 'Create Job Alert',
    EditJobAlert: 'Edit Job Alert'
  },
  message: {
    noJob: 'Oops! No jobs are matched.',
    tryOtherKeyword: 'Please try other keywords :)'
  }
}
